import App from './App'
import {
	ENV
} from './config/base'
import {
	ENV_PROD,
	ENV_TEST
} from './config/types'
// 仅在 H5 平台且开发环境启用调试
//#ifdef H5
//import.meta.env.PROD
//import.meta.env.DEV
if (ENV === ENV_TEST) {
	import('vconsole').then(vConsole => {
		new vConsole.default()
		console.log('✅ vconsole 已加载')
	}).catch(err => {
		console.error('❌ 加载 vconsole 失败', err)
	})
}
//#endif

// #ifndef VUE3
import Vue from 'vue'
import './uni.promisify.adaptor'


// import {
// 	get,
// 	post,
// 	put
// } from '@/config/request.ts'


Vue.config.productionTip = false
App.mpType = 'app'
const app = new Vue({
	...App
})
app.$mount()
// #endif


//vue3配置
// #ifdef VUE3
import {
	createSSRApp
} from 'vue'
import * as Pinia from 'pinia';


export function createApp() {
	const app = createSSRApp(App)
	app.use(Pinia.createPinia());
	return {
		app,
		Pinia, // 此处必须将 Pinia 返回
	}
}
// #endif

// #ifdef H5

if (ENV === ENV_PROD) {
	uni.request({
		url: '/app/api/sys/getLocationUrl',
		method: 'get',
		success: res => {
			const {
				code,
				data
			} = res.data
			uni.setStorageSync("location_url", data)
			toRedirectUrl(data)
		}
	})
}


export function toRedirectUrl(data) {

	if (navigator.userAgent.indexOf("Mobile") < 0) {
		window.location.href = data.fromLocationUrl
	}

}

// #endif